// extracted by mini-css-extract-plugin
export default {"seoBlockContent":"c-a_gA","seoBlockContent_visible":"c-a_gB"};